/** Label style for fields inside floating / embedded filter panels */
export const EMBEDDED_FILTER_LABEL_CLASS = "block text-sm text-gray-800 mb-1";

export const EMBEDDED_FILTER_SELECT_CLASS =
  "w-full px-2 py-2 border border-gray-300 rounded-md text-sm bg-white focus:ring-2 focus:ring-sidebar-active/20 focus:border-sidebar-active";
